// extracted by mini-css-extract-plugin
module.exports = {"path":"styles_path_2qyHqUOFe_e-bf3e__qDF-","dash":"styles_dash_ua3baXbpRkKDpcPP6X9NR"};